import React from "react";
import { Grid, CardContent, CardHeader, Card, Divider, Fab } from "@material-ui/core";
import DividentsTable from "./DividendsTable";
import AddIcon from "@material-ui/icons/Add";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { useDividendsData } from "../../../data/reports/dividends/hooks/useDividendsData";
import { useDividendsIndex } from "../../../data/reports/dividends/hooks/useDividendsIndex";
import { useHistory } from "react-router-dom";
import { DividendsFilterButton } from "./DividendsFilter";

import { PageDataStatus } from "../../../data/models";
import { useAuth } from "../../../data/auth/hooks";
import { getDividendsEditLocation } from "./Locations";

const DividendsPage: PageComponent = ({ userAccessRights }) => {
	const pageStyles = usePageStyles();

	const [pageData, dispatchLoadDividends] = useDividendsData();
	const [pageIndex, dispatchSetIndex] = useDividendsIndex();

	React.useEffect(() => {
		if (pageData && pageData.status === PageDataStatus.DataInvalidated) {
			dispatchLoadDividends();
		}
	}, [dispatchLoadDividends, pageData]);

	const history = useHistory();
	const [auth] = useAuth();

	if (auth.status !== "successful") {
		return null;
	}

	return (
		<>
			<Grid container className={pageStyles.root}>
				<Grid item xs={12} className={pageStyles.gridItem}>
					<Card>
						<CardHeader
							title={<PageTitle title="divTitle" />}
							action={<DividendsFilterButton />}
						/>
						<Divider />
						<CardContent>
							<DividentsTable
								pageIndex={pageIndex}
								pageData={pageData}
								onPageIndexChange={dispatchSetIndex}
								userAccessRights={userAccessRights}
								getData={dispatchLoadDividends}
							/>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			{userAccessRights === AccessRights.All && auth.user.roleCode == "BROKER" && (
				<Fab
					color="secondary"
					aria-label="add"
					className={pageStyles.mainFab}
					onClick={() => history.push(getDividendsEditLocation())}
				>
					<AddIcon />
				</Fab>
			)}

		</>
	);
};

export default DividendsPage;

